import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Paper,
  Switch,
  Typography,
} from "@mui/material";
import { ProductoGrid } from "../entities/Product";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import WorkIcon from "@mui/icons-material/Work";
import Divider from "@mui/material/Divider";
import DescriptionIcon from "@mui/icons-material/Description";
import StorefrontIcon from "@mui/icons-material/Storefront";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark";
import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { activeBoolToText } from "../../../utils/helpers";
import { ViewItem } from "../../../components/ViewItem/ViewItem";
import { Accordion } from "../../../components/Accordion/Accordion";
import { eTypeStorage } from "../../../enums/eTypeStorage";
import { useModal } from "../../../hooks/useModal";
import { Modal } from "../../../components/_EOS/Modal";
import { postExternalStorage } from "../api";
import { SnackBar } from "../../../components/SnackBar/Snackbar";
import { useSnackbar } from "../../../hooks/useSnackbar";
import { useApi } from "../../../hooks/useApi";
import { Status } from "../../../hooks/useFetchState";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  table: {
    minWidth: 400,
  },
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
}));

interface ViewProductoProps {
  elemento: ProductoGrid;
  refreshGrid: () => void;
}

export const ViewProducto: React.FC<ViewProductoProps> = ({
  elemento,
  refreshGrid,
}) => {
  const { state, callApi } = useApi();
  const classes = useStyles();
  const [checkControl, setcheckControl] = useState(false);
  const { isActive, message, openSnackBar, isSuccess } = useSnackbar();

  const {
    size: sizeModal,
    isOpen: isOpenModal,
    openModal,
    closeModal,
  } = useModal("");

  const handleSetData = () => {
    setcheckControl(!checkControl);
    if (!isOpenModal) {
      openModal("sm");
    }
  };

  const handleUpdateExternalStorage = (
    skuid: number,
    checkControl: boolean,
  ) => {
    let msg = "Actualización almacenamiento externo correctamente.";
    let resultOk = true;
    callApi(postExternalStorage(skuid, checkControl))
      .catch((error) => {
        msg = error;
        resultOk = false;
      })
      .finally(() => {
        closeModal();
        openSnackBar(msg, resultOk);
        if (resultOk) {
          refreshGrid();
        }
      });
  };

  const {
    id,
    name,
    sku,
    ean13,
    active,
    realHeight,
    realLength,
    realWeight,
    realWidth,
    shippingHeight,
    shippingWeight,
    shippingLength,
    shippingWidth,
    image,
    externalStorage,
    typeStorageId,
    batch,
    expirationDate,
    isGreenSale,
  } = elemento;

  useEffect(() => {
    setcheckControl(externalStorage);
  }, [externalStorage]);
  return (
    <Fragment>
      <Grid container direction="row" spacing={2}>
        <Grid item xs={12} md={6}>
          <List className={classes.root}>
            <ViewItem
              title="Nombre"
              text={name}
              icon={<BrandingWatermarkIcon />}
            />
            <Divider variant="inset" component="li" />
            <ViewItem title="SKU" text={sku} icon={<WorkIcon />} />
            <Divider variant="inset" component="li" />
          </List>
        </Grid>
        <Grid item xs={12} md={6}>
          <List>
            <ViewItem title="EAN13" text={ean13} icon={<StorefrontIcon />} />
            <Divider variant="inset" component="li" />
            <ViewItem
              title="Activo"
              text={activeBoolToText(active)}
              icon={<CheckBoxIcon />}
            />
            <Divider variant="inset" component="li" />
          </List>
        </Grid>

        <Grid item xs={12}>
          <List>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <DescriptionIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Descripción" secondary={elemento.name} />
            </ListItem>
            <Divider variant="inset" component="li" />
          </List>
        </Grid>
        <Grid item xs={12}>
          <List>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <DescriptionIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Almacenamiento externo"
                secondary={
                  <div>
                    <Switch
                      disabled={typeStorageId !== eTypeStorage.Mixto}
                      checked={checkControl}
                      // onChange={() => openModalLpnState('xs')}
                      onChange={handleSetData}
                      color="primary"
                      name="checkedB"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                    {checkControl ? "Activo" : "Inactivo"}
                  </div>
                }
              />
            </ListItem>
            <Divider variant="inset" component="li" />
          </List>
        </Grid>
        <Grid spacing={2}>
          {batch !== null && (
            <Grid item xs={12} md={6}>
              <List>
                <ViewItem
                  title="Contiene Lote"
                  text={batch ? "Si" : "No"}
                  icon={batch ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                />
                <Box mt={2}>{""}</Box>
                <Divider variant="inset" component="li" />
              </List>
            </Grid>
          )}

          {expirationDate !== null && (
            <Grid item xs={12} md={6}>
              <List>
                <ViewItem
                  title="Contiene Fecha Vencimiento"
                  text={expirationDate ? "Si" : "No"}
                  icon={
                    expirationDate ? (
                      <CheckBoxIcon />
                    ) : (
                      <CheckBoxOutlineBlankIcon />
                    )
                  }
                />
                <Divider variant="inset" component="li" />
              </List>
            </Grid>
          )}

          {isGreenSale !== null && (
            <Grid item xs={12} md={6}>
              <List>
                <ViewItem
                  title="Es Venta en Verde"
                  text={isGreenSale ? "Si" : "No"}
                  icon={
                    isGreenSale ? (
                      <CheckBoxIcon />
                    ) : (
                      <CheckBoxOutlineBlankIcon />
                    )
                  }
                />
                <Divider variant="inset" component="li" />
              </List>
            </Grid>
          )}
        </Grid>
        {image !== undefined && image.length > 0 ? (
          <Accordion title="Ver Imagen">
            <Grid
              container
              spacing={2}
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Grid item xs={8} justifyContent="center">
                <Paper variant="outlined">
                  <img
                    alt=""
                    src={image[0].url}
                    style={{ maxWidth: "75%", maxHeight: "50%" }}
                  />
                </Paper>
              </Grid>
            </Grid>
          </Accordion>
        ) : (
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={8} justifyContent="center">
              <ImageSearchIcon />
              <Typography>Sin Imagen</Typography>
            </Grid>
          </Grid>
        )}

        <Grid item xs={12} md={6} style={{ marginTop: "15px" }}>
          <Card className={classes.root}>
            <CardContent>
              <Typography variant="h5" component="h2">
                Medidas
              </Typography>
              <Typography variant="body2" component="p">
                <br />
                altura:{" "}
                {realHeight === undefined ? "" : realHeight.toString() + " cm"}
              </Typography>
              <Typography variant="body2" component="p">
                <br />
                ancho:{" "}
                {realWidth === undefined ? "" : realWidth.toString() + " cm"}
              </Typography>
              <Typography variant="body2" component="p">
                <br />
                longitud:{" "}
                {realLength === undefined ? "" : realLength.toString() + " cm"}
              </Typography>
              <Typography variant="body2" component="p">
                <br />
                peso:{" "}
                {realWeight === undefined ? "" : realWeight.toString() + " kg"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} style={{ marginTop: "15px" }}>
          <Card className={classes.root}>
            <CardContent>
              <Typography variant="h5" component="h2">
                Medidas Envío
              </Typography>
              <Typography variant="body2" component="p">
                <br />
                altura flete:{" "}
                {shippingHeight === undefined
                  ? ""
                  : shippingHeight.toString() + " cm"}
              </Typography>
              <Typography variant="body2" component="p">
                <br />
                ancho flete:{" "}
                {shippingWidth === undefined
                  ? ""
                  : shippingWidth.toString() + " cm"}
              </Typography>
              <Typography variant="body2" component="p">
                <br />
                longitud flete:{" "}
                {shippingLength === undefined
                  ? ""
                  : shippingLength.toString() + " cm"}
              </Typography>
              <Typography variant="body2" component="p">
                <br />
                peso flete:{" "}
                {shippingWeight === undefined
                  ? ""
                  : shippingWeight.toString() + " kg"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Modal
        loading={state.status === Status.Loading}
        open={isOpenModal}
        title={"Confirmación de almacenamiento externo"}
        onClose={closeModal}
        maxWidth={sizeModal}
        cancelButton={{
          action: closeModal,
          title: "Cancelar",
        }}
        successButton={{
          action: () => handleUpdateExternalStorage(id, checkControl),
          title: "Confirmar",
        }}
      >
        ¿Esta seguro que desea modificar el valor de almacenamiento externo?
        Esta acción puede tener un impacto critico en la función del WMS
      </Modal>
      <SnackBar
        message={message}
        status={isSuccess ? "success" : "error"}
        open={isActive}
      />
    </Fragment>
  );
};
